var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTask = function SvgTask(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-72": 48,
    viewBox: "0 0 21 22",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.15.9a.9.9 0 1 0-1.8 0v1H3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-14a3 3 0 0 0-3-3h-1.35v-1a.9.9 0 1 0-1.8 0v1h-8.7zm8.7 4V3.7h-8.7v1.2a.9.9 0 1 1-1.8 0V3.7H3a1.2 1.2 0 0 0-1.2 1.2V7h17.4V4.9A1.2 1.2 0 0 0 18 3.7h-1.35v1.2a.9.9 0 1 1-1.8 0M1.8 18.9V8.8h17.4v10.1a1.2 1.2 0 0 1-1.2 1.2H3a1.2 1.2 0 0 1-1.2-1.2m12.996-6.848a.9.9 0 0 0-1.242-1.304l-4.629 4.41-1.48-1.41a.9.9 0 1 0-1.24 1.304l2.1 2a.9.9 0 0 0 1.24 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTask);
export default ForwardRef;